import { ScheduleHelper } from '..';

export const useSchedule = () => {
	let scheduleHelper = new ScheduleHelper();
	return {
		scheduleHelper,
		activeSchedule: scheduleHelper.active()
	};
};
